import { render, staticRenderFns } from "./svg.vue?vue&type=template&id=8f143048&scoped=true"
var script = {}
import style0 from "./svg.vue?vue&type=style&index=0&id=8f143048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f143048",
  null
  
)

export default component.exports